<template>
  <div>
    <MasterLayout>
      <div class="voucher_first_row">
        <div
          class="voucher_first_row_right_section mr-3 vr__bg"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="transaction_period_text mt-4">
            <div class="row">
              <div class="col-md-6"></div>
              <div
                class="col-md-6 drop_down_input_group float-right"
                ref="date__picker"
              >
                <div class="drop_down_section mt-2 mr-2">
                  <div class="drop_down_div align-items-center">
                    <!-- <div class="drop_down_placeholder_icon">
                                            <img src="@/assets/img/add-event.png" class="ml-2"  />
                                        </div> -->

                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      :color="$store.getters.getDatePickerColor"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4 text-center">
              ({{ $t("text.subAccountDetails.title") }})
              {{ this.$route.query.email }}
            </div>
          </div>
          <div class="transaction_buttons_div mt-4">
            <div class="sub_account_buttons mb-3 mr-3">
              <button
                class="mr-3"
                @click="activateTab('voucher')"
                :class="[
                  activePane === 'voucher' ? 'activeSubAccountTab' : null,
                ]"
              >
                {{ $t("text.subAccountDetails.vouchers") }}
                <img
                  src="@/assets/img/paper-plane.png"
                  width="30px"
                  class="ml-3"
                />
              </button>
              <button
                class="mr-3"
                @click="activateTab('transaction')"
                :class="[
                  activePane === 'transaction' ? 'activeSubAccountTab' : null,
                ]"
              >
                {{ $t("text.subAccountDetails.transactions") }}
                <img
                  src="@/assets/img/paper-plane.png"
                  width="30px"
                  class="ml-3"
                />
              </button>
              <button
                class=""
                @click="activateTab('consumption')"
                :class="[
                  activePane === 'consumption' ? 'activeSubAccountTab' : null,
                ]"
              >
                {{ $t("text.subAccountDetails.consumptions") }}
                <img
                  src="@/assets/img/paper-plane.png"
                  width="30px"
                  class="ml-3"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <section class="section_2 mt-3">
        <div class="">
          <div class="section_2_table_section">
            <div class="row">
              <div class="col-md-7">
                <div class="table_label_div">
                  <div class="">
                    <h3
                      class="section_2_table_title ml-3"
                      v-if="activePane === 'voucher'"
                    >
                      {{ $t("text.subAccountDetails.vouchers") }}
                    </h3>
                    <h3
                      class="section_2_table_title ml-3"
                      v-if="activePane === 'transaction'"
                    >
                      {{ $t("text.subAccountDetails.transactions") }}
                    </h3>
                    <h3
                      class="section_2_table_title ml-3"
                      v-if="activePane === 'consumption'"
                    >
                      {{ $t("text.subAccountDetails.consumptionRecords") }}
                    </h3>
                  </div>
                </div>
              </div>
              <div class="col-md-5 mt-3">
                <div
                  class="table_dropdown_list_div"
                  v-if="
                    activePane === 'transaction' || activePane === 'consumption'
                  "
                >
                  {{ $t("text.subAccountDetails.transBetween") }}
                  {{
                    $d(new Date(startDate), "short", this.$root.$i18n.locale)
                  }}
                  {{ $t("text.and.text") }}
                  {{ $d(new Date(endDate), "short", this.$root.$i18n.locale) }}
                </div>
              </div>
            </div>
            <div ref="consumption_table">
              <ejs-grid
                v-show="!showLoader"
                ref="consumptionDataGrid"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="consumptionToolbarClick"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column field="index" width="40" headerText="#"></e-column>
                  <e-column
                    field="date"
                    width="200"
                    :headerText="$t('text.subAccountDetails.date')"
                  ></e-column>
                  <e-column
                    field="volSold"
                    width="100"
                    :headerText="$t('text.subAccountDetails.volume')"
                  ></e-column>
                  <e-column
                    field="priceSold"
                    width="120"
                    textAlign="Right"
                    :headerText="$t('text.subAccountDetails.pricePerLitre')"
                  ></e-column>
                  <e-column
                    field="voucherAmount"
                    width="160"
                    textAlign="Right"
                    :headerText="$t('text.subAccountDetails.voucherAmount')"
                  ></e-column>
                  <e-column
                    field="priceSoldCash"
                    width="140"
                    textAlign="Right"
                    :headerText="$t('text.subAccountDetails.amountPaid')"
                  ></e-column>
                  <e-column
                    field="branchName"
                    width="140"
                    :headerText="$t('text.subAccountDetails.stationName')"
                  ></e-column>
                  <e-column
                    field="city"
                    width="100"
                    :headerText="$t('text.subAccountDetails.city')"
                  ></e-column>
                  <e-column
                    field="state"
                    width="120"
                    :headerText="$t('text.subAccountDetails.state')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
            </div>

            <div ref="transaction_table">
              <ejs-grid
                v-show="!showLoader"
                ref="transactionDataGrid"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="transactionToolbarClick"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column field="index" width="40" headerText="#"></e-column>
                  <e-column
                    field="date"
                    width="200"
                    :headerText="$t('text.subAccountDetails.date')"
                  ></e-column>
                  <e-column
                    field="status"
                    width="120"
                    :headerText="$t('text.subAccountDetails.status')"
                  ></e-column>
                  <e-column
                    field="amount"
                    width="150"
                    textAlign="Right"
                    :headerText="$t('text.subAccountDetails.amount')"
                  ></e-column>
                  <e-column
                    field="source"
                    width="190"
                    :headerText="$t('text.subAccountDetails.remark')"
                  ></e-column>
                  <e-column
                    field="currentBalance"
                    width="150"
                    textAlign="Right"
                    :headerText="$t('text.subAccountDetails.currentBalance')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
            </div>
            <div ref="voucher_table">
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :locale="usedLang"
              >
                <!-- field="pin" -->
                <e-columns>
                  <e-column field="index" width="40" headerText="#"></e-column>
                  <e-column
                    field="pin"
                    :template="cTemplate"
                    width="200"
                    :headerText="$t('text.subAccountDetails.voucher')"
                  ></e-column>
                  <e-column
                    field="date"
                    width="200"
                    :headerText="$t('text.subAccountDetails.dateCreated')"
                  ></e-column>
                  <e-column
                    field="amount"
                    width="140"
                    textAlign="Right"
                    :headerText="$t('text.subAccountDetails.amount')"
                  ></e-column>
                  <e-column
                    field="returnBalanceTo"
                    width="170"
                    :headerText="$t('text.subAccountDetails.returnBalanceTo')"
                  ></e-column>
                  <e-column
                    field="isUsed"
                    width="100"
                    :headerText="$t('text.subAccountDetails.isUsed')"
                  ></e-column>
                  <e-column
                    field="paymentMethod"
                    width="150"
                    :headerText="$t('text.subAccountDetails.source')"
                  ></e-column>
                  <e-column
                    field="expiry"
                    width="150"
                    :headerText="$t('text.subAccountDetails.expiryDate')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
            </div>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import JQuery from "jquery";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

let $ = JQuery;

export default {
  title: "Sub Accounts:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },

      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      activeVoucher: "generated",
      genVouchers: null,
      transVouchers: null,
      expVouchers: null,
      transferedVouchers: 0,
      expiredVouchers: 0,
      showEmptyTableMessage: false,
      generatedVouchers: 0,
      corpId: null,
      activePane: "voucher",
      vouchersArray: [],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      transactionData: null,
      consumptionData: null,
      cTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<div><span>{{crossWord(data.pin)}} </span>&nbsp; <a class="show-pin pull-right" :data-pin="data.pin" v-on:click="click($event)"><i class="fa fa-eye"></i></a></div>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              click: function (e) {
                this.$eventHub.$emit("detail", e);
              },
              crossWord: function (word) {
                let pre = word.substr(0, 2);
                let suff = word.substr(word.length - 1, 1);
                let xes = "";
                for (let i = 0; i < word.length - 3; i++) {
                  xes += "X";
                }
                return pre + xes + suff;
              },
            },
          }),
        };
      },
      checkBoxTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div><input type="checkbox" v-on:change="createMailArray($event, data)"/></div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              createMailArray: function (e, v) {
                this.$eventHub.$emit("voucherCheck", e, v);
              },
            },
          }),
        };
      },
      selectAllTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div><input type="checkbox" v-on:change="selectAll($event)"/></div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              selectAll: function (e) {
                this.$eventHub.$emit("selectAll", e);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("detail", (e) => {
      this.togglePin(e);
    });

    this.$eventHub.$on("voucherCheck", (event, voucher) => {
      this.createSendSmsMailArray(event, voucher);
    });

    this.$eventHub.$on("selectAll", (event) => {
      this.selectAll(event);
    });

    this.corpId = this.$route.query.email;
  },
  beforeDestroy() {
    this.$eventHub.$off("detail");
    this.$eventHub.$on("voucherCheck");
    this.$eventHub.$on("selectAll");
  },
  mounted() {
    this.getVouchers();
    this.getTransactionData();
    this.getConsumptionTable();
    this.$refs.transaction_table.style.display = "none";
    this.$refs.consumption_table.style.display = "none";

    this.$refs.date__picker.style.display = "none";
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTransactionData();
        this.getConsumptionTable();
      }
    },
  },
  methods: {
    activateTab(activePane) {
      this.activePane = activePane;

      if (
        this.genVouchers === null ||
        this.transactionData === null ||
        this.consumptionData === null
      ) {
        this.showEmptyTableMessage = true;
      }
      if (activePane === "transaction") {
        this.$refs.voucher_table.style.display = "none";
        this.$refs.transaction_table.style.display = "block";
        this.$refs.consumption_table.style.display = "none";

        this.$refs.date__picker.style.display = "block";
      }
      if (activePane === "consumption") {
        this.$refs.voucher_table.style.display = "none";
        this.$refs.transaction_table.style.display = "none";
        this.$refs.consumption_table.style.display = "block";

        this.$refs.date__picker.style.display = "block";
      }
      if (activePane === "voucher") {
        this.$refs.voucher_table.style.display = "block";
        this.$refs.transaction_table.style.display = "none";
        this.$refs.consumption_table.style.display = "none";
        this.$refs.date__picker.style.display = "none";

        this.$refs.date__picker.style.display = "none";

        this.getVouchers();
      }
    },
    pdfOrientation(fileName) {
      let pdfExportProperties = {
        pageOrientation: "Landscape",
        fileName,
      };
      return pdfExportProperties;
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.getColumns()[0].width = "60";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "120";
          this.$refs.dataGrid.getColumns()[4].width = "120";
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(
            this.pdfOrientation("Sub-Accounts Vouchers.pdf")
          );
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Sub-Accounts Vouchers.xlsx",
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }
      setTimeout(() => {
        this.$refs.dataGrid.getColumns()[0].width = "40";
        this.$refs.dataGrid.getColumns()[1].width = "200";
        this.$refs.dataGrid.getColumns()[2].width = "200";
        this.$refs.dataGrid.getColumns()[3].width = "140";
        this.$refs.dataGrid.getColumns()[4].width = "170";
        this.$refs.dataGrid.getColumns()[5].width = "100";
        this.$refs.dataGrid.getColumns()[6].width = "150";
        this.$refs.dataGrid.getColumns()[7].width = "150";
      }, 1000);
    },
    consumptionToolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.consumptionDataGrid.getColumns()[0].width = "60";
          this.$refs.consumptionDataGrid.getColumns()[1].width = "140";
          this.$refs.consumptionDataGrid.getColumns()[2].width = "120";
          this.$refs.consumptionDataGrid.getColumns()[3].width = "100";
          this.$refs.consumptionDataGrid.getColumns()[4].width = "120";
          this.$refs.consumptionDataGrid.getColumns()[5].width = "120";
          this.$refs.consumptionDataGrid.getColumns()[6].width = "120";
          this.$refs.consumptionDataGrid.getColumns()[7].width = "80";
          this.$refs.consumptionDataGrid.getColumns()[8].width = "120";
          this.$refs.consumptionDataGrid.pdfExport(
            this.pdfOrientation("Sub-Accounts Consumption.pdf")
          );
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Sub-Accounts Consumption.xlsx",
          };
          this.$refs.consumptionDataGrid.excelExport(excelExportProperties);
          break;
      }
      setTimeout(() => {
        this.$refs.consumptionDataGrid.getColumns()[0].width = "40";
        this.$refs.consumptionDataGrid.getColumns()[1].width = "200";
        this.$refs.consumptionDataGrid.getColumns()[2].width = "100";
        this.$refs.consumptionDataGrid.getColumns()[3].width = "120";
        this.$refs.consumptionDataGrid.getColumns()[4].width = "160";
        this.$refs.consumptionDataGrid.getColumns()[5].width = "140";
        this.$refs.consumptionDataGrid.getColumns()[6].width = "140";
        this.$refs.consumptionDataGrid.getColumns()[7].width = "100";
        this.$refs.consumptionDataGrid.getColumns()[8].width = "120";
      }, 1000);
    },
    transactionToolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.transactionDataGrid.getColumns()[0].width = "60";
          this.$refs.transactionDataGrid.getColumns()[1].width = "220";
          this.$refs.transactionDataGrid.getColumns()[2].width = "180";
          this.$refs.transactionDataGrid.getColumns()[3].width = "180";
          this.$refs.transactionDataGrid.getColumns()[4].width = "180";
          this.$refs.transactionDataGrid.getColumns()[5].width = "160";
          this.$refs.transactionDataGrid.pdfExport(
            this.pdfOrientation("Sub-Accounts Transactions.pdf")
          );
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Sub-Accounts Transactions.xlsx",
          };
          this.$refs.transactionDataGrid.excelExport(excelExportProperties);
          break;
      }
      setTimeout(() => {
        this.$refs.transactionDataGrid.getColumns()[0].width = "40";
        this.$refs.transactionDataGrid.getColumns()[1].width = "200";
        this.$refs.transactionDataGrid.getColumns()[2].width = "120";
        this.$refs.transactionDataGrid.getColumns()[3].width = "150";
        this.$refs.transactionDataGrid.getColumns()[4].width = "190";
        this.$refs.transactionDataGrid.getColumns()[5].width = "150";
      }, 1000);
    },
    refreshGrid() {
      if (this.$refs.dataGrid === null) {
        this.$refs.dataGrid.refresh();
      } else if (this.$refs.consumptionDataGrid === null) {
        this.$refs.consumptionDataGrid.refresh();
      } else if (this.$refs.transactionDataGrid === null) {
        this.$refs.transactionDataGrid.refresh();
      }
    },
    selectAll(event) {
      event.preventDefault();
      let _this = this;
      if (event.target.checked) {
        // Iterate each checkbox
        $(":checkbox").each(function () {
          this.checked = true;
        });
        _this.vouchersArray = _this.genVouchers;
      } else {
        $(":checkbox").each(function () {
          this.checked = false;
        });
        _this.vouchersArray = [];
      }
    },
    createSendSmsMailArray($event, voucherInfo) {
      if (!$event.target.checked) {
        let newVouchersArray = this.vouchersArray.filter(
          (voucher) => voucher.id !== voucherInfo.id
        );
        this.vouchersArray = newVouchersArray;
      } else {
        this.vouchersArray.push({
          id: voucherInfo.id,
          amount: voucherInfo.amount,
          pin: voucherInfo.pin,
        });
      }
    },
    sendMessage(mode) {
      localStorage.setItem(
        "messageDetails",
        JSON.stringify(this.vouchersArray)
      );
      this.$router.push({ name: "send_voucher", query: { mode: mode } });
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    getVouchers() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Voucher/VoucherList?u=${this.$route.query.email}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          this.showLoader = false;
          response.data.vouchers.forEach((voucher) => {
            index++;
            if (voucher.isUsed) {
              voucher.isUsed = "Yes";
            } else {
              voucher.isUsed = "No";
            }

            if (voucher.deleted) {
              voucher.expiry = "Cancelled";
            } else {
              if (voucher.expiry === null) {
                voucher.expiry = "Never";
              } else {
                var varDate = this.$moment(voucher.expiry);
                var today = this.$moment();
                if (today > varDate) {
                  voucher.expiry = "Expired";
                } else {
                  voucher.expiry = this.$moment(voucher.expiry).format(
                    "ddd, d MMM, YYYY hh:mm A"
                  );
                }
              }
            }
            //voucher.pin = this.Xword(voucher.pin);
            voucher.date = this.$moment(voucher.date).format(
              "DD-MM-YYYY h:mm A"
            );
            voucher.index = index;
          });
          this.genVouchers = response.data.vouchers;
          grid.ej2Instances.setProperties({
            dataSource: response.data.vouchers,
          });
          this.generatedVouchers = response.data.vouchers.length;
          this.refreshGrid();
        })
        .catch((error) => {
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: "Network Error, Please Check Your Internet Connection",
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: "An Error Occured",
              type: "error",
              duration: 5000,
            });
          }
        });
    },
    getConsumptionTable() {
      this.showLoader = true;
      let grid = this.$refs.consumptionDataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Track/FuelConsumptionTable?u=${this.$route.query.email}&startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.consumption.forEach((consumption) => {
            index++;
            if (isFinite(consumption.volSold)) {
              consumption.volSold = consumption.volSold
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
              consumption.volSold = 0.0;
            }

            if (isFinite(consumption.voucherAmount)) {
              consumption.voucherAmount = consumption.voucherAmount
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
              consumption.voucherAmount = 0.0;
            }

            if (isFinite(consumption.priceSoldCash)) {
              consumption.priceSoldCash = consumption.priceSoldCash
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
              consumption.priceSoldCash = 0.0;
            }

            consumption.index = index;
            consumption.date = this.$moment(consumption.date).format(
              "DD-MM-YYYY h:mm A"
            );
          });
          this.consumptionData = response.data.consumption;
          this.showLoader = false;
          grid.ej2Instances.setProperties({
            dataSource: response.data.consumption,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    getTransactionData() {
      let grid = this.$refs.transactionDataGrid;
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Wallet/Transactions?u=${this.$route.query.email}&startDate=${this.startDate}&endDate=${this.endDate}&id=${this.corpId}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.transactions.forEach((transaction) => {
            index++;
            if (transaction.status === "Add") {
              transaction.status = "Credit";
            } else if (transaction.status === "Removal") {
              transaction.status = "Debit";
            }
            if (transaction.amount) {
              transaction.amount = transaction.amount
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            if (transaction.currentBalance) {
              transaction.currentBalance = transaction.currentBalance
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            transaction.date = this.$moment(transaction.date).format(
              "DD-MM-YYYY h:mm A"
            );
            transaction.index = index;
          });
          this.showLoader = false;
          grid.ej2Instances.setProperties({
            dataSource: response.data.transactions,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    showFundWalletModal() {
      this.$modal.show("fund-wallet");
    },
    Xword(word) {
      let pre = word.substr(0, 2);
      let suff = word.substr(word.length - 1, 1);
      let xes = "";
      for (let i = 0; i < word.length - 3; i++) {
        xes += "X";
      }
      return pre + xes + suff;
    },
    togglePin(event) {
      event.preventDefault();
      var caller = $(event.target).parent();
      var span = caller.siblings("span");
      var pin = caller.attr("data-pin");
      var hash = span.text();
      if (caller.hasClass("showing")) {
        //hide
        span.text(pin);
        caller.attr("data-pin", hash);
        caller
          .removeClass("showing")
          .find("i.fa")
          .removeClass("fa-eye-slash")
          .addClass("fa-eye");
      } else {
        //show
        span.text(pin);
        caller.attr("data-pin", hash);
        caller
          .addClass("showing")
          .find("i.fa")
          .removeClass("fa-eye")
          .addClass("fa-eye-slash");
      }
    },
  },
  beforeDestroy() {
    this.$eventHub.$off("detail");

    this.$eventHub.$off("voucherCheck");

    this.$eventHub.$off("selectAll");
  },
};
</script>
